export const LocalSessionKey = {
  IS_SERVICE_TYPE_SELECTED_ONECE: 'IS_SERVICE_TYPE_SELECTED_ONECE',
  TABLE_ID: 'TABLE_ID',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  USER_ID: 'USER_ID',
  OUTLET_ID: 'OUTLET_ID',
  MOBILE_NO: 'MOBILE_NO',
  LAT_LNG: 'LAT_LNG',
  USER_DETAIL: 'USER_DETAIL',
  USER_DATA: 'USER_DATA',
  RECENT_SEARCH: 'RECENT_SEARCH',
  ORDER_TYPE: 'ORDER_TYPE',
  PLATFORM: 'PLATFORM',
  NAME: 'NAME',
  RESTAURANT_DETAIL: 'RESTAURANT_DETAIL',
  APP_VERSION: 'APP_VERSION',
  ENCRYPTION_KEY: 'ENCRYPTION_KEY',
  TOKEN: 'TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  MAX_EMP_DISC_VALUE: 'MAX_EMP_DISC_VALUE',
  DEVICE_NAME: 'DEVICE_NAME',
  OS_VERSION: 'OS_VERSION',
  DEVICE_BRAND: 'DEVICE_BRAND',
  OS_NAME: 'OS_NAME',
  DEVICE_MODEL: 'DEVICE_MODEL',
  THEATRE_RESPONSE: 'THEATRE_RESPONSE',
  NEW_USER: 'NEW_USER',
  ESTIMATED_TIME: 'ESTIMATED_TIME',
  IS_ESTIMATED_TIME: 'IS_ESTIMATED_TIME',
  TIPS_AMT: 'TIPS_AMT',
  NEARBY_BK_RESTUARANT: 'NEARBY_BK_RESTUARANT',
  DEEP_LINK_OUTLET_ID: 'DEEP_LINK_OUTLET_ID',
  CROWNS: 'crowns',
  CHARITY_STATUS: 'is_charity',
  DONATION_POP_UP_STATUS: 'DONATION_POP_UP_STATUS',
  USER_LOCATION: 'USER_LOCATION'
};
